export default {
    /**
     * 获取分时图或者K线图
     * @param hand 手动更新
     */
    get_MinuteOrKLine() {
        if (this.mkTimeOutHand) {
            clearTimeout(this.mkTimeOutHand);
        }
        this.$api.getMinuteOrKLine(this.nowTag[1], this.detailCode).then(res => {
            if (res.data.code === 1) {
                if (this.nowTag[1] === 'minute') {
                    this.mdata = res.data.data;
                } else {
                    this.kdata = res.data.data;
                }
            }
            if (this.nowTag[1] === 'minute' && this.isopen) {
                this.mkTimeOutHand = setTimeout(() => {
                    this.get_MinuteOrKLine();
                }, this.$globle.upMinuteTime)
            }
        })
    }
}
